import { PeriodicityEnum, PlanTypeEnum } from '@/types/generated/graphql';
import { create, StateCreator } from 'zustand';
import { SubscriptionType } from '../subscription.types';
import { toISO } from '../utils/toISO';

const subscriptionState: StateCreator<SubscriptionType> = (set) => ({
  memberSubscriptionOverview: null,
  setMemberSubscriptionOverview: (memberSubscriptionOverview) => {
    set({ memberSubscriptionOverview });
  },
  planSubscription: null,
  numberSubscription: null,
  periodicity: PeriodicityEnum.year,
  planPrices: null,
  planType: PlanTypeEnum.business,
  setPeriodicity: (periodicity: string | null) => set({ periodicity }),
  setPlanType: (planType: PlanTypeEnum | null) => set({ planType }),
  setSubscription: (subscription) => {
    // Set number subscription
    const numSub =
      subscription?.listSubscription?.edges?.find((sub) => sub?.itemProductFamily === 'twilio-number') || null;

    // Set plan Subscription
    const planSubRaw =
      subscription?.listSubscription?.edges?.find((sub) => sub?.itemProductFamily === 'calilio-workspace') || null;

    // Can't mutate directly, so creating shallow copy
    const planSub = planSubRaw
      ? {
          ...planSubRaw,
          currentTermEnd: toISO(planSubRaw.currentTermEnd),
        }
      : null;

    const isPremium = planSub?.subscriptionItems?.[0]?.itemPriceId?.split('-')?.[2] === 'premium';

    const planType = isPremium ? PlanTypeEnum.business : PlanTypeEnum.basic;
    const periodicity = planSub?.billingPeriodUnit || null;

    set({ planSubscription: planSub, numberSubscription: numSub, periodicity, planType });
  },
  listPaymentSource: null,
  setListPaymentSource: (listPaymentSource) => {
    set({ listPaymentSource });
  },
  setPlanPrices: (planPrices) => {
    set({ planPrices });
  },
});

export const useSubscriptionStore = create(subscriptionState);
